import styles from './FJRecordPermission.module.less';
import FJPermissionIcon from '../../../../assets/svg/permission.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAIAudioConfig from '../../../../config/appConfig/FJAIAudioConfig.js';
const FJRecordPermission = () => {
    return (
        <div className={styles.box}>
            <FJPermissionIcon />
            <div className={styles.permissions_title}>{FJLocalStore._('failed-to-start-recording-voice')}</div>
            <div className={styles.permissions_desc}>
                {FJLocalStore._('please-check-the-microphone-device-and-enable-microphone-access-in-your-browser')}
            </div>
            <div className={styles.permissions_demo}>
                <video src={FJAIAudioConfig.recordVideoPath} autoPlay loop />
            </div>
        </div>
    );
};

export default FJRecordPermission;
